<template>
  <div class="video-content">
    <video-player class="video-player vjs-custom-skin"
      ref="videoPlayer" 
      :playsinline="true" 
      :options="playerOptions"
      @pause="onPlayerPause($event)"
      @play="onPlayerPlay($event)"
    ></video-player>
  </div>
</template>

<script>
  export default {
    props: {
      playerOptions:{
        type: Object,
        default: ()=>{}
      },
      index: {
        type: Number,
        default: 0
      },
      videoId: {
        type: String,
        default: ''
      }
    },
    computed: {
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    data() {
      return {
        play: false,//播放还是暂停 true播放中
      }
    },
    created () {
      this.$nextTick(()=>{
        document.getElementsByTagName('video')[0].setAttribute('controlslist', 'nodownload')
      })
    },
    methods: {
      onPlayerPlay(){
        this.play = true
        this.$parent.isPlay = true
        this.addlog()
      },
      onPlayerPause(){
        this.play = false
        this.$parent.isPlay = false
      },
      addlog(){
       this.axios.get(`https://new-videoapi.ayerdudu.com/vc_${this.videoId}.html`)
      }
    },
  }
</script>

<style lang="less" scoped>
.video-content{
  position: relative;
  height: 100%;
  width: 100%;
  font-size: 16px;
  .video-player{
    width: 100%;
    height: 100%;
    /deep/.vjs-control-bar{
      font-size: 18px;
    }
    /deep/.video-js{
      width: 100%;
      height: 100%;
    }
    /deep/.vjs-poster{
      // background-size: cover;
      // background-size: 100%;
      background-size: auto 100%;
    }
     /deep/.vjs-play-control{
       &:focus, &:hover{
        text-shadow: none !important;
        border: none;
        box-shadow: none;
       }
    }
    /deep/.vjs-volume-panel{
      display: none;
    }

    /deep/.vjs-tech::-internal-media-controls-download-button {
      display:none !important;
    }
    /deep/.vjs-tech::-webkit-media-controls-enclosure {
      overflow: hidden !important;
    }

    /deep/video::-internal-media-controls-download-button {
      display:none !important;
    }
    /deep/video::-webkit-media-controls-enclosure {
      overflow: hidden !important;
    }

  }
  .obscuration{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.1;
    z-index: 4;
  }
  .play{
    display: block;
    width: 58px;
    height: 72px;
    position: absolute;
    top: 45%;
    left: 50%;
    z-index: 6;
    margin: -36px 0 0 -29px;
  }
  img{
    width: 100%;
    height: 100%;
  }
  .btn{
    display: block;
    width: 44px;
    height: 48px;
    position: absolute;
    z-index: 6;
    top: 45%;
    margin-top: -24px;
    &.play-top{
      left: 152px;
    }
    &.play-bottom{
      right: 152px;
    }
    &.noVideo{
      opacity: 0.5;
    }
  }
}
</style>
<style>
video::-internal-media-controls-download-button {
  display:none;
}
video::-webkit-media-controls-enclosure {
  overflow:hidden;
}
</style>